import { render, staticRenderFns } from "./CreateForm.vue?vue&type=template&id=6944e259&"
import script from "./CreateForm.vue?vue&type=script&lang=ts&"
export * from "./CreateForm.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports